import { reflectKeys } from "@utils/key.reflactor.ts";

export const RESOURCE_TAGGING_RESOURCE_TYPE = reflectKeys(["LESSON", "QUIZ", "QUESTION", "RUBRIC"]);

export const CONTENT_MAP_WARNING_CONTEXT = {
  LEARNING_PROGRESS: "LEARNING_PROGRESS",
  MOE_LIBRARY: "MOE_LIBRARY",
} as const;

export type ContentMapWarningContext =
  (typeof CONTENT_MAP_WARNING_CONTEXT)[keyof typeof CONTENT_MAP_WARNING_CONTEXT];
